import { useCallback } from 'react'

import pdfMake from 'pdfmake/build/pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { TDynamicKey } from '../../../utils/type'
import { configPdfMakeDefault } from '../../../utils/pdfMake'
// import { toJS } from 'mobx'

const { vfs } = vfsFonts.pdfMake
pdfMake.vfs = vfs
pdfMake.fonts = {
    THSarabun: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf',
    },
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf',
    },
}

type TDataImage = {
    image: string
    title: string
}

type TDataTable = Array<TDynamicKey | string>

type TDataDocDefinitionParam = {
    title: string
    dataTable: Array<TDataTable>
    dataImage: Array<TDataImage>
    [key: string]: any
}

type TGetDocDefinitionPdfParam = {
    data: Array<TDataDocDefinitionParam>
    maxCol?: number
}

const useExportReportComparePDF = ({ ...props }) => {
    const getDocDefinitionPdf = useCallback(({ data = [], maxCol = 7 }: TGetDocDefinitionPdfParam) => {
        const docDefinition = {
            ...configPdfMakeDefault,
            content: [
                ...data.map(({ title, dataTable, dataImage }: any) => {
                    return [
                        { text: title, style: 'header' },
                        generateTable(dataTable, maxCol),
                        ...generateImage(dataImage),
                    ]
                }),
            ],
        } as TDocumentDefinitions
        return docDefinition
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const generateTable = useCallback((dataTable: any[], maxCol) => {
        let widths: Array<number | string> = []
        if (dataTable.length > 0) {
            const maxDataCol = dataTable[1].length === 7 ? 284 : 350
            const firstCol = dataTable[1].length === 7 ? 170 : 290
            const widthCol = Math.trunc(maxDataCol / maxCol)
            widths = [firstCol, ...Array(dataTable[0].length - 1).fill(widthCol)]

            if (dataTable[1].length <= 3) {
                const widthCol = 202
                widths = [370, ...Array(dataTable[0].length - 1).fill(widthCol)]
            }
        }
        return {
            style: 'table',
            color: '#444',
            table: {
                widths: widths,
                headerRows: 2,
                body: dataTable,
            },
        }
    }, [])

    const generateImage = useCallback((generateImage) => {
        let image: any[] = []

        generateImage.forEach((item: any) => {
            const page = [
                {
                    text: '',
                    pageBreak: 'before',
                },
                {
                    text: `${item.title}`,
                    style: 'header',
                },
                {
                    stack: [
                        {
                            image: item.image,
                            width: 400,
                            height: 400,
                            alignment: 'center',
                        },
                    ],
                    // margin: [left, top, right, bottom]
                    margin: [20, 50, 20, 20],
                    alignment: 'center',
                },
            ]

            image = [...image, page]
        })

        return image
    }, [])

    const downloadPdf = useCallback((props: { data?: any[] }, maxCol) => {
        const { data = [] } = props
        const docDefinition = getDocDefinitionPdf({ data, maxCol })
        pdfMake.createPdf(docDefinition).download('รายงานเปรียบเทียบคะแนนการประเมิน')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openPdf = useCallback((props: { data?: any }, maxCol) => {
        const { data = [] } = props

        const docDefinition = getDocDefinitionPdf({ data, maxCol })

        pdfMake.createPdf(docDefinition).open()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { downloadPdf, openPdf, generateTable, generateImage, getDocDefinitionPdf }
}

export default useExportReportComparePDF
